import { useTreatments } from '@splitsoftware/splitio-react'
import { useGetUserProfile } from 'Features/userProfile/api/getUserProfile'

const featureName = 'CE_12_INSTALLMENTS_ENABLE_CHANGES'

export const use12InstallmentsAllowChanges = () => {
  const { data: userProfile } = useGetUserProfile()
  const SplitTreatment = useTreatments([featureName], {
    email: userProfile?.email.split('@')[1] || '',
  })
  return SplitTreatment[featureName].treatment === 'on'
}
